import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import AiSection from "../components/AiSection";
import MajorFunctions from "../components/MajorFunctions";
import ProductSelection from "../components/ProductSelection";
import PetFoundLost from "../components/PetFoundLost";
import Footer from "../components/Footer";
import Sponsors from "../components/Sponsors";

const Home = () => {
  const pageStyle = {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  };

  const contentStyle = {
    flex: "1 0 auto",
    marginTop: "40px",
  };

  return (
    <div style={pageStyle}>
      <Navbar />
      <div style={contentStyle}>
        <HeroSection />
        <MajorFunctions /> 
        <AiSection />
        <PetFoundLost />
        <ProductSelection />
        <Sponsors />
      </div>
      <Footer />
    </div>
  );
};

export default Home;
